import React from "react";
import styles from "./CartListPage.module.css";
import PropTypes from "prop-types";
import history from "core/helper/Helper";
import Button from "@material-ui/core/Button";
import { RouterPrivateName } from "shared/RouterPrivateName";
import { CartTable } from "admin/components/Cart";

function CartListPage(props) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => history.push(RouterPrivateName.HomePage.url)}
        >
          Home
        </Button>
      </div>
      <CartTable />
    </div>
  );
}

CartListPage.propTypes = {};

export default CartListPage;
